import request from '@/router/axios'
import qs from 'qs'
export function roleList() {
  return request({
    url: '/role/roleList',
    method: 'get'
  })
}
export function fetchList(query) {
  return request({
    url: '/role/rolePage',
    method: 'post',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    },
    params: query
  })
}
export function deptRoleList(deptId) {
  return request({
    url: '/admin/role/roleList/' + deptId,
    method: 'get'
  })
}
export function getObj(id) {
  return request({
    url: '/role/info',
    method: 'post',
    params: id
  })
}
export function addObj(obj) {
  return request({
    url: '/role/add',
    method: 'post',
    params: obj
  })
}
export function putObj(obj) {
  return request({
    url: '/role/update',
    method: 'post',
    params: obj
  })
}
// 删除
export function delObj(id) {
  return request({
    url: '/role/del',
    method: 'post',
    params: id
  })
}
// 分配角色
export function allotObj(id) {
  return request({
    url: '/platformUser/',
    method: 'post',
    params: id
  })
}
// 分配角色确定
export function addsObj(obj) {
  return request({
    url: '/role/addUser',
    method: 'post',
    params: obj
  })
}
// 更新/role/roleMenuUpd
export function permissionUpd(obj) {
  return request({
    url: '/role/roleMenuUpd',
    method: 'post',
    params: obj,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
// 权限
export function fetchRoleTree(query) {
  return request({
    url: '/menu/roleTree',
    method: 'post',
    params: query
  })
}
// 部门
export function fetchDeptTree(query) {
  return request({
    url: '/dept/tree',
    method: 'post',
    params: query
  })
}

// 权限回写
export function findMenuByRole(query,role) {
  return request({
    url: '/menu/findMenuByRole/'+role,
    method: 'post',
    params: query
  })
}
